import { styled } from '@material-ui/core';
import { colors, div } from '../common';
import * as React from 'react';
import { Linked } from '@type-r/react';
import { Tabs } from '@material-ui/core';

const TransparentTabsContext = React.createContext( null );

export const TabsDivider = styled( 'div' )({
    height: 70,
    width: 1,
    backgroundColor: 'rgba(255,255,255,0.25)',
});

export const TransparentTabs =
    styled(
        ({ $value, children, className }) => {
            return (
                <TransparentTabsContext.Provider value={ $value }>
                    <div className={ className }>
                        { children }
                    </div>
                </TransparentTabsContext.Provider>
            )
        }
    )({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    })

export const TransparentTab =
    styled(
        ({ value, className = "", children, disabled }: {
            value : any,
            className? : string,
            children : React.ReactNode,
            disabled? : boolean
        }) => {
            const $value = React.useContext( TransparentTabsContext );

            return (
                <div
                    className={ className + ( $value.value === value ? ' selected' : '' )}
                    onClick={ () => {
                        disabled || $value.set( value )
                    }}
                >
                    {children}
                </div>
            )
        }
    )({
        margin: 4,
        padding: 8,
        borderRadius: 3,
        cursor: 'pointer',
        '&.selected' : {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        }
    });


export const LinearProgress = styled(
        ({ value, max, color, className }) =>
            <div className={className}>
                <div className="progress"/>
            </div>

    )({
        width: "100%",
        borderRadius: 5,
        height: 5,
        backgroundColor: 'rgba(1,1,1,0.1)',

        "& .progress": {
            height: '100%',
            backgroundColor: ( x : any ) => colors[ x.color ],
            width: ( x : any ) => x.max ? String( x.value / x.max * 100 ) + '%': 0
        }
    })

export const PageTab = ({ title, subtitle, disabled, value, label, children }:{
    title : string,
    label : string,
    disabled? : boolean,
    className? : string,
    value : string,
    subtitle? : string,
    children? : React.ReactNode
}) =>
    <TransparentTab value={value} disabled={disabled}>
        <PageTabRoot disabled={disabled}>
            <div className="title">{title}</div>
            <div className="container">
                <div className="main-info">{label}</div>
                <div className="subtitle">
                    {subtitle}
                </div>
            </div>
            { children }
        </PageTabRoot>
    </TransparentTab>

const PageTabRoot = div({
    display: "flex",
    flexDirection: "column",
    color: ( props : any ) => props.disabled ? "#A0A0A0" : '#FFF',
    fontFamily: 'Montserrat',

    '& .main-info' : {
        flex: "1 auto",
        fontSize: 22,
        fontWeight: 300,
    },

    '& .container' : {
        display: "flex",
        padding: 0,
        flexDirection: "row",
        alignItems: 'baseline',
    },

    '& .title' : {
        fontSize: 12,
        fontWeight: 600,
        textTransform: 'uppercase'
    },

    '& .subtitle' : {
        fontSize: 12,
        fontWeight: 500,
        marginLeft: 12
    }
});

export const NavigationTabs = styled(
  ({
    className,
    $value,
    children
  }: {
    className?: string;
    $value: Linked<string>;
    children: React.ReactNode;
  }) => {
    return (
      <div className={className}>
        <Tabs
          value={$value.value}
          onChange={(_, x) => {
            $value.set(x);
          }}
        >
          {children}
        </Tabs>
      </div>
    );
  }
)({
  backgroundColor: "#052C4C",
  display: "flex",
  "& .MuiTab-textColorInherit": {
    color: "white"
  }
});

export const Triangle = div({
  width: 16,
  position: "absolute",
  height: 16,
  backgroundColor: "#052C4C",
  top: 50,
  left: (props: any) => props.left,
  transform: "rotate(45deg)"
});
